//var jQuery = require('jquery');
define(['jquery'], function($) {
    /**
     * Live validation client side jQuery plugin. Server side is backed up with RamJet validation servlet that responds to
     * the client request with validation results.
     *
     * Usage:
     *
     * $("#form").liveValidation({ ... settings ... });
     *
     * All inputs in the specified form are then automatically enriched with live validation controls unless they are disabled
     * or marked with class "noLiveValidation".
     *
     * --------------------------------------------------------------------------------------------------------------------
     * Custom settings:
     * --------------------------------------------------------------------------------------------------------------------
     * validationUrlHandler(location): function returning URL to the validation servlet -
     *                                 BY DEFAULT its the current page location that has replaces /qf/ fragment
     *                                 with /validate/ fragment
     * replaceHandler(widget):         function that replaces contents of the inline messages containers
     *                                 widget parameter contains JSON results for particular widget (see API section)
     *                                 BY DEFAULT it simply replaces contents with jQuery.html() method call,
     *                                 see $.liveValidation.predefinedMethods for other ways of replacing messages contents
     * preventSubmitOnErrors:          set to true if you want to prevent user to submit form if there are known validation
     *                                 errors, for most cases it requires one additional AJAX call on form submit request
     *                                 (note: by setting true you'll also prevent double form submits)
     *                                 BY DEFAULT false
     * showTipsInInputs:               fills input[type=text] and textarea contents with their title attribute if there is any
     *                                 when user enters particular field hint content value is removed
     *                                 there is always class "hintDisplayed" present on the input if it contains hint value
     *                                 BY DEFAULT true
     * failedCallback(settings, liveValidationManager, form, jqXHR, textStatus, errorThrown):
     *                                 callback called on server error - failing to process validation request
     *                                 BY DEFAULT no function
     * successCallback(settings, liveValidationManager, form, xhr, textStatus, result):
     *                                 callback called on server validation result (also with widget errors) - success in this
     *                                 case means, that server successfuly processed our validation request
     *                                 BY DEFAULT no function
     * validationNotNecessaryHandler(event):
     *                                 callback called on field validation request when value hasn't changed against last
     *                                 validated value
     *                                 BY DEFAULT only logs event skip
     * minimalWaitInterval:            minimal time interval between validation calls (to prevent server overhead)
     *                                 requests on the server are always performed in serial way (one after another) with
     *                                 minimal time distance of minimalWaitInterval value
     *                                 BY DEFAULT 1000ms
     *
     * --------------------------------------------------------------------------------------------------------------------
     * Events:
     * --------------------------------------------------------------------------------------------------------------------
     * validationFailed          - invoked on form element in case it contains ANY widget with validation error
     * validationPassed          - invoked on form element in case it contains NO widget with validation error
     * validationPassedForWidget - invoked on each validated widget element when live validation passes WITHOUT ERROR
     * validationFailedForWidget - invoked on each validated widget element when live validation fails WITH ERROR
     * requestValidation         - trigger this event manually on any monitored form input element to trigger live validation check
     *
     * --------------------------------------------------------------------------------------------------------------------
     * API documentation:
     * --------------------------------------------------------------------------------------------------------------------
     *
     * Request - POST with there arguments:
     * Live-Validation-Context-Id:         unique validation context id - identificator for stored server side
     *                                            validation context, that is in sync with client side
     * Live-Validation-Form:               id of the user input container (ie HTML form) that represents
     *                                            scope of the validation
     * Live-Validation-Requested-Widgets:  semicolon delimited list of widgets, that have changed values and should
     *                                            be repopulated on server and whose inline messages should be rendered
     *                                            on return
     *
     * + standard submit data for all input widgets and submit button
     *
     * Response JSON:
     *
     * {
 *   "data": {
 *      "requires": string, // one of values: nothing, convertedData, validatedData - represents what level of validation
 *                          // server requests for invoking particular event
 *      "validationContextId": string, // unique validation context id - identificator for stored server side
 *                                     // validation context, that is in sync with client side
 *        "widgets": {
 *           "widgetName": {
 *              "hasErrors": boolean, // true if widget data are invalid
 *              "hasInfos": boolean,  // true if server side has any comment to widget data
 *              "hasMessages": boolean, // true if messages property is not empty (see next row)
 *              "messages": string, // contains message rendered on the server side that is connected to this widget
 *              "validatedValue": string, // contains last value validated by server (connected with these results)
 *              "widgetId": string, // contains normalized widget id (ie id attribute of the HTML input element)
 *              "widgetInputName": string, // contains widget name (ie name attribute of the HTML input element)
 *              "widgetMessageId": string, // contains normalized id of widget messages subwidget (ie id attribute of inline messages component)
 *              "widgetName": string // contains absolute id of the widget
 *          },
 *          ... more widgets ...
 *      }
 *   },
 *   "error": boolean, // returns true if there was error while processing validation request
 *   "errorMessage": string, // contains string explaining the error on server
 *   "ok": boolean // return true if there was no error while processing validation request
 *  }
     *
     * @author Jan Novotny
     * @version 1.0
     */
    (function ($) {

        $.liveValidationManager = function () {
            //contains all current validation requests
            this.widgetValidationRequests = [];
            //contains all validation requests since last successful call to server
            this.pendingWidgetValidationRequests = [];
            //true / false if there is XHR request pending
            this.xhrRunning = false;
            //contains timestamp of the last server call
            this.lastServerCall = null;
            //this global variable holds current validationContextId negotiated with the server
            this.validationContextId = null;
            //contains reference to pending validation call
            this.timeoutSet = null;
            //contains flag if submit is being processed
            this.submitInProcess = false;
            //contains information about last validated values for each input
            this.validatedValues = {};
            //contains all DOM elements that has been already visited by user
            this.visitedInputs = {};
            this.visitedInputIds = {};
            //contains last server call result
            this.lastValidationResult = null;
            //contains all validated widget messages
            this.widgetMessages = {};
            //force submit (will skip error validation)
            this.forceSubmit = false;
            //stores information about last clicked button (used for postponed submits)
            this.clickedEvent = null;
        }

        $.liveValidationManager.prototype = {

            /**
             * Logs a text into the firebug.
             * @param text
             */
            _log: function (text) {
                if ($.log === undefined) {
                    if (window.console) {
                        window.console.log(text);
                    }
                } else {
                    $.log(text);
                }
            },

            /**
             * Returns true if it is necessary to call server validation. Return true only if there has been some activity
             * in input widgets.
             * @param settings
             * @param form
             */
            _validationNecessary: function (settings, form) {
                return this.widgetValidationRequests.length > 0 || this.validationContextId === null;
            },

            /**
             * Executes ajax call - if partialUpdate is on the same page it uses its queue to synchronize requests.
             *
             * @param settings
             */
            _ajax: function (settings) {
                if ($.partialUpdate && $.partialUpdate.ajaxManager) {
                    settings.clearCache = true;
                    $.partialUpdate.ajaxManager.executeAjaxCall(settings);
                } else {
                    $.ajax(settings);
                }
            },

            _startServerCall: function () {
                this.xhrRunning = true;
                this._log("Validation request running ...");
                this.lastServerCall = new Date();
                //copy all current requests and empty the queue
                var validatedWidgets = this.widgetValidationRequests;
                this.pendingWidgetValidationRequests = this.widgetValidationRequests;
                this.widgetValidationRequests = [];
                return validatedWidgets;
            },

            _successFinishServerCall: function (settings, form, result, textStatus, xhr) {
                this.xhrRunning = false;
                this._log("Validation request finished.");
                if (result.error === true) {
                    //copy back widgets that should have been validated and were not
                    for (var i in this.pendingWidgetValidationRequests) {
                        var requestedAgain = false;
                        var pendingWidgetValidationRequest = this.pendingWidgetValidationRequests[i];
                        for (var j in this.widgetValidationRequests) {
                            var currentValidationRequest = this.widgetValidationRequests[j];
                            if (currentValidationRequest == pendingWidgetValidationRequest) {
                                requestedAgain = true;
                                break;
                            }
                        }
                        if (!requestedAgain) {
                            this.widgetValidationRequests.push(pendingWidgetValidationRequest);
                        }
                    }
                    //handle error
                    if (result.errorMessage.indexOf("Error 01") > -1) {
                        this._log("Validation context id " + this.validationContextId + " no longer exists. Initiating new context handshake.")
                        this.validationContextId = null;
                        this._validateOnServer(settings, form);
                    } else if (result.errorMessage.indexOf("Error 02") > -1) {
                        this._log("Parallel server call occured. Issuing new call with timeout.");
                        setTimeout(this._validateOnServer.call(this, settings, form), 200);
                    } else {
                        this._log("Unknown error on server: " + result.errorMessage);
                        //call callback function if required
                        if ($.isFunction(settings.failedCallback)) {
                            settings.failedCallback(settings, form, xhr, "500", result.errorMessage);
                        }
                    }
                } else {
                    if (this.validationContextId === null) {
                        this.validationContextId = result.data.validationContextId;
                    }
                    //render messages
                    var anyErrors = false;

                    //this closure has logic content only on second and subsequent calls
                    //it marks widget DOM element with error class and triggers events for them
                    var handleUpdate = function (widget) {
                        var widgetRef = $("#" + widget.widgetId, form);
                        var widgetRefCnt = $("#" + widget.widgetId + "__container", form);
                        if (widgetRefCnt.length === 0) {
                            widgetRefCnt = widgetRef.parents(".errorContainer");
                            if (widgetRefCnt.length === 0) {
                                widgetRefCnt = widgetRef;
                            }
                        }
                        if (widget.hasErrors) {
                            widgetRefCnt.addClass(settings.fieldErrorClass, true);
                        } else {
                            widgetRefCnt.removeClass(settings.fieldErrorClass);
                        }
                        if (true === widget.hasMessages) {
                            this.widgetMessages[widget.widgetId] = widget.messages;
                            settings.replaceHandler.call(this, widget, form);
                        }
                    };


                    for (var validatedWidget in result.data.widgets) {
                        //iterate over all widgets and fire events for them and examine their result
                        var widget = result.data.widgets[validatedWidget];
                        var widgetRef = $("#" + widget.widgetId, form);
                        this.validatedValues[widget.widgetInputName] = widget.validatedValue;
                        if (widget.hasErrors) {
                            anyErrors = true;
                            widgetRef.trigger("validationFailedForWidget", widget.widgetId);
                        } else {
                            widgetRef.trigger("validationPassedForWidget", widget.widgetId);
                        }
                        //visualize error / info only for already visited widgets
                        if (this.visitedInputs[widget.widgetInputName] === true) {
                            handleUpdate.call(this, widget);
                            for (var messageKey in widget.keyedMessages) {
                                var widgetVariant = jQuery.extend(
                                    true, {}, widget,
                                    {
                                        widgetId: widget.widgetId + "-" + messageKey,
                                        widgetMessageId: widget.widgetMessageId + "-" + messageKey,
                                        messages: widget.keyedMessages[messageKey],
                                        hasErrors: widget.hasKeyedErrors[messageKey]
                                    }
                                );
                                var visitedInputId = this.visitedInputIds[widget.widgetInputName];
                                if (visitedInputId && visitedInputId[widgetVariant.widgetId] === true) {
                                    handleUpdate.call(this, widgetVariant);
                                }
                            }
                        }
                    }

                    var containerStatus = result.data.containerStatus;
                    if (containerStatus && $("#" + containerStatus.widgetMessageId).length > 0) {
                        settings.replaceHandler.call(this, containerStatus, form);
                        $.liveValidation.predefinedMethods.containerMessagesAnimator(containerStatus);
                    }

                    this.lastValidationResult = result;
                    if (anyErrors) {
                        $(form).trigger("validationFailed");
                    } else {
                        $(form).trigger("validationPassed");
                    }
                    //call callback function if required
                    if ($.isFunction(settings.successCallback)) {
                        settings.successCallback(settings, this, form, xhr, textStatus, result);
                    }
                }
            },

            _failureFinishServerCall: function (settings, form, jqXHR, textStatus, errorThrown) {
                this._log("Failed to validate: " + textStatus + "(" + errorThrown + ")");
                this.xhrRunning = false;
                //call callback function if required
                if ($.isFunction(settings.failedCallback)) {
                    settings.failedCallback(settings, this, form, jqXHR, textStatus, errorThrown);
                }
            },

            /**
             * Tweaked jQuery serialize array including file types.
             * @param node
             */
            _specificSerializeArray: function (settings, node) {
                return node.map(function () {
                    return this.elements ? jQuery.makeArray(this.elements) : this;
                })
                    .filter(function () {
                        return this.name && !this.disabled &&
                            (this.checked || /select|textarea/i.test(this.nodeName) ||
                            /text|hidden|password|search|file|number|email|url|tel|range|date|month|week|time|datetime|datetime-local|color/i.test(this.type));
                    })
                    .map(
                        function (i, elem) {
                            var val = jQuery(this).val();
                            if (settings.showTipsInInputs === true && (elem.type == "text" || /textarea/i.test(this.nodeName))) {
                                if (val == elem.title) {
                                    val = "";
                                }
                            }
                            return val == null ? null :
                                jQuery.isArray(val) ?
                                    jQuery.map(val, function (val, i) {
                                        return {name: elem.name, value: val};
                                    }) :
                                {name: elem.name, value: val};
                        }).get();
            },

            /**
             * This function will call server logic for validation results.
             * @param settings
             * @param form
             */
            _validateOnServer: function (settings, form) {
                var validatedWidgets = this._startServerCall();

                //prepare form data for validation along with context id
                var ajaxData;
                if (this.validationContextId === null) {
                    ajaxData = this._specificSerializeArray(settings, $(form));
                } else {
                    ajaxData = [];
                    ajaxData[ajaxData.length] = {
                        name: "Live-Validation-Context-Id",
                        value: this.validationContextId
                    };
                    if (this.clickedEvent) {
                        ajaxData[ajaxData.length] = {
                            name: this.clickedEvent.target.name,
                            value: this.clickedEvent.target.value
                        };
                    }
                }
                var widgetNames = "";
                var processedNames = {};
                for (var i = 0; i < validatedWidgets.length; i++) {
                    var validatedWidget = validatedWidgets[i]
                    var widgetName = typeof validatedWidget === "string" ? validatedWidget : $(validatedWidget).attr("name");
                    if (processedNames[widgetName] !== true) {
                        processedNames[widgetName] = true;
                        var inputElement = $(form).find("*[name=\"" + widgetName + "\"]");
                        var inputElementValue = this._specificSerializeArray(settings, inputElement);
                        for (var j = 0; j < inputElementValue.length; j++) {
                            ajaxData.push(inputElementValue[j]);
                        }
                        //complete concatenated string of all widgets that needs to be validated
                        if (widgetNames.length > 0) {
                            widgetNames += ";"
                        }
                        widgetNames += widgetName;
                    }
                }
                ajaxData[ajaxData.length] = {
                    name: "Live-Validation-Requested-Widgets",
                    value: widgetNames
                };
                ajaxData[ajaxData.length] = {
                    name: "Live-Validation-Form",
                    value: $(form).attr("id")
                };
                if (settings.ramJetLayoutContext) {
                    ajaxData[ajaxData.length] = {
                        name: 'ramJetLayoutContext',
                        value: settings.ramJetLayoutContext
                    };
                }
                //derive target url from current location
                var validationUrl = settings.validationUrlHandler(window.location);
                var liveValidationMgr = this;
                //call server finally
                this._ajax({
                    type: "POST",
                    url: validationUrl,
                    data: ajaxData,
                    dataType: 'json',
                    success: function (result, textStatus, xhr) {
                        liveValidationMgr._successFinishServerCall.call(liveValidationMgr, settings, form, result, textStatus, xhr)
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        liveValidationMgr._failureFinishServerCall.call(liveValidationMgr, settings, form, jqXHR, textStatus, errorThrown)
                    }
                });
            },

            /**
             * Returns true if any errors are present or form has not been yet checked.
             * @param settings
             * @param form
             */
            _anyErrorsPresent: function (settings, form) {
                var errorsPresent = this.lastValidationResult === null;
                if (errorsPresent === false) {
                    var widgetData = this.lastValidationResult.data.widgets;
                    for (var widgetStatusKey in widgetData) {
                        if (widgetData[widgetStatusKey].hasErrors === true) {
                            errorsPresent = true;
                        }
                    }
                }
                return errorsPresent;
            },

            /**
             * Method executes form submit.
             * @param event
             * @param form
             * @param callback
             */
            _executePostponedSubmit: function (event, form, callback) {
                if ($.isFunction(callback)) {
                    if (callback(event, form) === false) {
                        return false;
                    }
                }
                if (this.clickedEvent) {
                    var clickedEvent = this.clickedEvent;
                    var clickedButton = clickedEvent.target;
                    if (clickedButton.type.toLocaleLowerCase() == "submit") {
                        $("<input id=\"" + clickedButton.id + "_ramJetLiveValidationFakeInput\" type=\"hidden\" name=\"" + clickedButton.name + "\" value=\"" + clickedButton.value + "\"/>").appendTo(form);
                        this.forceSubmit = true;
                        this.submitInProcess = true;
                        form.submit();
                        //we have to remove created hidden fields in order to clear battleground for cases when someone other stops submitting the form
                        //or submit leads to the standalone window and original DOM is reused for other submits
                        $("#" + clickedButton.id + "_ramJetLiveValidationFakeInput").remove();
                    } else if (clickedButton.type.toLocaleLowerCase() == "image") {
                        var elementOffset = $(clickedEvent.target).offset();
                        $("<input id=\"" + clickedButton.id + "_ramJetLiveValidationFakeInputX\" type=\"hidden\" name=\"" + clickedButton.name + ".x\" value=\"" + Math.round(clickedEvent.pageX - elementOffset.left) + "\"/>").appendTo(form);
                        $("<input id=\"" + clickedButton.id + "_ramJetLiveValidationFakeInputY\" type=\"hidden\" name=\"" + clickedButton.name + ".y\" value=\"" + Math.round(clickedEvent.pageY - elementOffset.top) + "\"/>").appendTo(form);
                        this.forceSubmit = true;
                        this.submitInProcess = true;
                        form.submit();
                        //we have to remove created hidden fields in order to clear battleground for cases when someone other stops submitting the form
                        //or submit leads to the standalone window and original DOM is reused for other submits
                        $("#" + clickedButton.id + "_ramJetLiveValidationFakeInputX").remove();
                        $("#" + clickedButton.id + "_ramJetLiveValidationFakeInputY").remove();
                    }
                }
            },

            /**
             * Focuses first input that has error registered.
             *
             * @param settings
             * @param form
             */
            _focusOnFirstError: function (settings, form) {
                if (this.lastValidationResult) {
                    var indexedInputRegex = /.*?-(\d+)$/;
                    var widgetInputIndex = {};
                    var widgetStatuses = this.lastValidationResult.data.widgets;
                    for (var widgetName in widgetStatuses) {
                        var widgetStatus = widgetStatuses[widgetName];
                        widgetInputIndex[widgetStatus.widgetInputName] = widgetStatus;
                    }
                    var inputs = $(form).find("input, select, textarea").not(":submit, :reset, :image, [disabled]")
                    for (var i = 0; i < inputs.length; i++) {
                        var input = inputs.get(i);
                        var matches = indexedInputRegex.exec(input.id);
                        var indexed = matches != null;
                        var widgetResult = widgetInputIndex[input.name];
                        if (widgetResult && widgetResult.hasErrors &&
                            (!indexed || widgetResult.hasKeyedErrors[matches[1]])) {
                            $('html, body').animate({
                                scrollTop: $(input).offset().top
                            }, 250);
                            input.focus();
                            return;
                        }
                    }
                }
            },

            /**
             * Registers input as visited.
             * @param inputName
             * @param inputId
             */
            _registerVisitedInput: function (inputName, inputId) {
                this.visitedInputs[inputName] = true;
                var widgetIds = this.visitedInputIds[inputName];
                if (!widgetIds) {
                    widgetIds = {};
                    this.visitedInputIds[inputName] = widgetIds;
                }
                if (inputId) {
                    widgetIds[inputId] = true;
                }
            },

            /**
             * This method is called when UI input element gets modified and should be validated against backend logic.
             * @param settings
             */
            requestValidation: function (settings, event) {
                var inputName = event.target.name;
                var inputId = event.target.id;
                var validatedValue = this.validatedValues[inputName];
                var isAlreadyValidatedValue = function (value) {
                    if (validatedValue === undefined) {
                        validatedValue = "";
                    }
                    return validatedValue == value;
                };

                var getNewValue = function () {
                    var jForm = $(event.target).parents("form");
                    var inputElement = jForm.find("*[name=\"" + event.target.name + "\"]");
                    var value = this._specificSerializeArray(settings, inputElement);
                    var joinedValue = "";
                    for (valueItem in value) {
                        if (joinedValue != "") {
                            joinedValue += "|";
                        }
                        joinedValue += value[valueItem].value;
                    }
                    return joinedValue;
                }
                var newValue = getNewValue.call(this);
                if (settings.showTipsInInputs === true && newValue == $(event.target).attr("title")) {
                    newValue = "";
                }

                var doValidateFunction = function () {
                    for (var i = 0; i < this.widgetValidationRequests.length; i++) {
                        if (this.widgetValidationRequests[i] == event.target) {
                            return;
                        }
                    }
                    if (true !== this.visitedInputs[inputName]) {
                        this._log("Requested first validation for: " + inputName + "(value: " + newValue + ")");
                    } else {
                        this._log("Requested validation for: " + inputName + "(old value: " + validatedValue + ", new value: " + newValue + ")");
                    }
                    this._registerVisitedInput.call(this, inputName, inputId);
                    this.widgetValidationRequests.push(event.target);
                    this.validate(settings, $(event.target).parents("form"));
                };

                var type = event.target.type.toLocaleLowerCase();
                var checkableAndEmpty = ("checkbox" == type || "radio" == type) && !event.target.checked;
                var alreadyValidated = isAlreadyValidatedValue(newValue);
                var notVisitedYet = this.visitedInputs[inputName] !== true;
                if (!alreadyValidated || notVisitedYet || (alreadyValidated && checkableAndEmpty)) {
                    doValidateFunction.call(this);
                } else {
                    if (settings.validationNotNecessaryHandler.call(this, event)) {
                        doValidateFunction.call(this);
                    }
                }
            },

            /**
             * This method is called when form is requested to be submitted.
             * @param settings
             * @param event
             * @param data
             * @param defferedLambda
             */
            requestSubmit: function (settings, event, data, defferedLamda) {
                if (data && data === $.partialUpdate && !defferedLamda) {
                    return true;
                }
                var executePostponedLogic = defferedLamda;
                if (settings.preventSubmitOnErrors && this.forceSubmit === false) {
                    if (!executePostponedLogic) {
                        executePostponedLogic = function () {
                            liveValidationMgr._executePostponedSubmit.call(liveValidationMgr, event, form, settings.successCallback);
                        }
                    }

                    if (this.submitInProcess === false) {
                        var form = event.target.tagName.toLocaleLowerCase() == "form" ? $(event.target) : $(event.target).parents("form");
                        this._registerVisitedInput(form.attr("name"), form.attr("id"));
                        this.widgetValidationRequests.push(form.get(0));
                        var liveValidationMgr = this;
                        //test whether validation isn't already running
                        if (this.xhrRunning === true) {
                            //postpone late validation
                            if (this.timeoutSet !== null) {
                                clearTimeout(this.timeoutSet);
                            }
                            this._log("Postponing submit handling - validation is currently running ...");
                            this.timeoutSet = setTimeout(function () {
                                if (liveValidationMgr.requestSubmit(settings, event, data, defferedLamda)) {
                                    executePostponedLogic();
                                }
                            }, 300);
                            return false;
                        } else {
                            //execute immediately
                            if (this.lastValidationResult) {
                                //register all error widgets that has no error messages displayed next to them
                                var widgetData = this.lastValidationResult.data.widgets;
                                for (var widgetStatusKey in widgetData) {
                                    var widgetStatus = widgetData[widgetStatusKey];
                                    var me = this;
                                    me._registerVisitedInput.call(this, widgetStatus.widgetInputName);
                                    form.find("input, select, textarea").each(function () {
                                        me._registerVisitedInput.call(me, widgetStatus.widgetInputName, $(this).attr("id"));
                                    });
                                    this.widgetValidationRequests.push(widgetStatus.widgetInputName);
                                }
                                //execute post after validation has been performed
                                this._validateOnServer($.extend(
                                    {
                                        successCallback: function (settings, mgr, form, xhr, textStatus, result) {
                                            if (liveValidationMgr._anyErrorsPresent.call(liveValidationMgr, settings, form) === false) {
                                                liveValidationMgr._log.call(liveValidationMgr, "No errors in form found ... continuing with submit.");
                                                executePostponedLogic();
                                            } else if (liveValidationMgr.lastValidationResult.data.requires == "nothing") {
                                                liveValidationMgr._log.call(liveValidationMgr, "This kind of event doesn't require validation ... continuing with submit.");
                                                executePostponedLogic();
                                            } else {
                                                var containerStatus = result.data.containerStatus;
                                                if (containerStatus && $("#" + containerStatus.widgetMessageId).length > 0) {
                                                    settings.replaceHandler.call(this, containerStatus, form);
                                                    $.liveValidation.predefinedMethods.containerMessagesAnimator(containerStatus);
                                                } else {
                                                    liveValidationMgr._focusOnFirstError.call(liveValidationMgr, settings, form);
                                                }
                                            }
                                        },
                                        failedCallback: function () {
                                            liveValidationMgr._executePostponedSubmit.call(liveValidationMgr, event, form, settings.failedCallback);
                                        }
                                    },
                                    settings
                                ), form);
                                event.preventDefault();
                                event.stopPartialUpdate = true;
                                return false;
                            } else {
                                //validation results not available, rather submit form and let server validate
                                return true;
                            }
                        }
                    } else {
                        //submit is already being processed
                        event.preventDefault();
                        event.stopPartialUpdate = true;
                        return false;
                    }
                }
            },

            /**
             * This method is called when form is about to be submited.
             * @param settings
             */
            validate: function (settings, form) {
                if (this._validationNecessary(settings, form)) {
                    var tooEarly = this.lastServerCall !== null && new Date().getTime() < this.lastServerCall.getTime() + settings.minimalWaitInterval;
                    if (this.xhrRunning || tooEarly) {
                        //postpone call to next time frame
                        if (this.timeoutSet === null) {
                            var liveValidationMgr = this;
                            this.timeoutSet = setTimeout(
                                function () {
                                    liveValidationMgr.timeoutSet = null;
                                    liveValidationMgr.validate(settings, form);
                                },
                                this.lastServerCall.getTime() - new Date().getTime() + 1
                            )
                        }
                    } else {
                        this._validateOnServer(settings, form);
                    }
                }
            }
        };

        $.liveValidation = {
            predefinedMethods: {

                /**
                 * Animates container message errors if any.
                 * @param containerStatus
                 */
                containerMessagesAnimator: function (containerStatus) {
                    setTimeout(function () {
                            $("#" + containerStatus.widgetMessageId).click("a[data-focus]", function (event) {
                                var input = $("#" + $(event.target).attr("data-focus"));
                                $('html, body').animate({
                                    scrollTop: $(input).offset().top
                                }, 250);
                                input.focus();
                                event.preventDefault();
                                return false;
                            })
                        }
                        , 250);
                },

                /**
                 * Performs simple messages replace.
                 * @param status
                 */
                simpleReplace: function (status, form) {
                    var widgetEl = $('#' + status.widgetId, form);
                    var messageEl = $("#" + status.widgetMessageId, form)
                    var inputGroup = widgetEl.parents('.input-group');
                    var controlGroup = widgetEl.parents('.form-group');
                    if (inputGroup.length > 0) {
                        messageEl.insertAfter(inputGroup);
                    }

                    if (controlGroup.length > 0) {
                        if (status.hasErrors) {
                            controlGroup.addClass('has-error');
                        } else {
                            controlGroup.removeClass('has-error');
                        }
                    }
                    messageEl.replaceWith(status.messages);
                },

                /**
                 * Performs simple messages replace with animation.
                 * @param status
                 */
                simpleAnimatedReplace: function (status) {
                    var $widgetMessages = $("#" + status.widgetMessageId);
                    $widgetMessages.hide("normal", function () {
                        $widgetMessages.replaceWith(status.messages).show("normal")
                    });
                },

                /**
                 * Logs information that validation would be skipped (not necessary as value has not changed)
                 * @param event
                 */
                simpleValidationNotNecessaryHandler: function (event) {
                    this._log("Validated value hasn't changed - validation request stopped for: " + event.target.id);
                    return false;
                }

            }
        }

        $.fn.liveValidation = function (settings) {
            //noinspection MagicNumberJS
            var finalSettings = $.extend({
                preventSubmitOnErrors: false,
                validationUrlHandler: function (location) {
                    return location.href.replace("/qf/", "/validate/")
                },
                replaceHandler: $.liveValidation.predefinedMethods.simpleReplace,
                validationNotNecessaryHandler: $.liveValidation.predefinedMethods.simpleValidationNotNecessaryHandler,
                minimalWaitInterval: 1000,
                fieldErrorClass: "error",
                ramJetLayoutContext: null
            }, settings);

            var hasPlaceholderSupport = function () {
                var input = document.createElement('input');
                return ('placeholder' in input);
            }();
            var useHtml5Placeholders = hasPlaceholderSupport && finalSettings.showTipsInInputs === true;
            if (useHtml5Placeholders) {
                finalSettings.showTipsInInputs = false;
            }

            //bind handlers to inputs and buttons in forms
            return this.each(function () {
                var innerLvForms = $(this).find("form");
                var lvForms = $(this).filter("form").add(innerLvForms);
                lvForms.each(function () {
                    if (!$(this).data("liveValidation")) {
                        var liveValidationMgr = new $.liveValidationManager();
                        $(this).data("liveValidation", liveValidationMgr);

                        //hints part
                        if (finalSettings.showTipsInInputs === true) {
                            var removeHintFct = function () {
                                var me = $(this);
                                if (me.val() == me.attr("title")) {
                                    me.val("").removeClass("hintDisplayed");
                                }
                            };
                            var addHintFct = function () {
                                var me = $(this);
                                if (me.val() == "" && !(me.get(0) == document.activeElement)) {
                                    me.val(me.attr("title")).addClass("hintDisplayed");
                                }
                            };
                            $("input:text, textarea", this).on("focus", removeHintFct).on("blur", addHintFct).each(function () {
                                addHintFct.call(this);
                            });
                            //after partial update replacement immediately fill in hints
                            $(this).bind("afterContentsReplaced", function () {
                                $("input:text, textarea", this).each(function () {
                                    addHintFct.call(this);
                                });
                            });
                            $(this).bind("validationFailed", function () {
                                $("input:text, textarea", this).each(function () {
                                    addHintFct.call(this);
                                });
                            });
                            $(this).submit(function (event, data) {
                                $("input:text, textarea", this).each(function () {
                                    removeHintFct.call(this);
                                });
                            });
                        }
                        else if (useHtml5Placeholders === true) {
                            $("input:text, textarea", this).each(function () {
                                var $this = $(this);
                                if ($this.attr("title") == $this.attr("placeholder")) {
                                    $this.removeAttr("title");
                                }
                            });
                        }

                        //validation part
                        liveValidationMgr.validate(finalSettings, this);
                        var triggerRequestValidation = function () {
                            var jThis = $(this);
                            if (jThis.not(":button, :reset, :submit, :hidden, :image, [disabled], .noLiveValidation, .customValidationTrigger").length == 1) {
                                jThis.trigger("requestValidation");
                            }
                        };
                        $(this).on("requestValidation", function (event) {
                            liveValidationMgr.requestValidation(finalSettings, event)
                        });
                        $(this).on("blur", "input", function () {
                            triggerRequestValidation.call(this)
                        });
                        $(this).on("blur", "select", function () {
                            triggerRequestValidation.call(this)
                        });
                        $(this).on("blur", "textarea", function () {
                            triggerRequestValidation.call(this)
                        });
                        $(this).on("click", ":submit, :image", function (event) {
                            var targetType = event.target.tagName.toLowerCase();
                            if (targetType == "input" || targetType == "button") {
                                liveValidationMgr.clickedEvent = event;
                            }
                        });
                        $(this).on("click", ":radio, :checkbox", function () {
                            triggerRequestValidation.call(this)
                        });
                        $(this).on("change", "select", function () {
                            triggerRequestValidation.call(this)
                        });
                        $(this).bind("beforeContentsReplaced", function (event, result, textStatus, xhr, settings, container) {
                            $(container).find("input, select, textarea").each(function () {
                                var inputName = $(this).attr("name");
                                if (liveValidationMgr.visitedInputs[inputName] === true) {
                                    liveValidationMgr.visitedInputs[inputName] = false;
                                    liveValidationMgr.visitedInputIds[inputName] = {};
                                    liveValidationMgr._log.call(liveValidationMgr, "Removing input " + inputName + " from visited ones - it gets replaced by partial update.");
                                }
                            });
                        });
                        $(this).submit(function (event, data, defferedLamda) {
                            var targetType = event.target.tagName.toLowerCase();
                            if (targetType == "input" || targetType == "button") {
                                liveValidationMgr.clickedEvent = event;
                            }
                            return liveValidationMgr.requestSubmit(finalSettings, event, data, defferedLamda);
                        });
                    }
                });
            });
        }

    })(jQuery);
});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/ramjet/new/jquery.liveValidation.js